function throttle(t,e,n){e||(e=250);var a,r;return function(){var u=n||this,i=+new Date,o=arguments;a&&a+e>i?(clearTimeout(r),r=setTimeout(function(){a=i,t.apply(u,o)},e)):(a=i,t.apply(u,o))}}

var itqVideoGlobal = false;
var itqVideoPaused = false;
var itqVideoPlayer;

(function($) {
	function evaluateImageLoading() {
		var scroll = $(window).scrollTop();
		var viewport = window.innerHeight;
		var loadin = scroll + viewport;

		$('.galleries__post__images:not(.galleries__post__images--loaded)').each(function() {
			var offset = $(this).offset().top;

			if (offset >= scroll && offset <= loadin) {
				lazyLoadImages($(this));
			}
		});
  }

  function initItqVideo() {
    var itqVideo = $('.itq-video video');

		if (!itqVideo.length) {
			return;
		}

		itqVideoGlobal = itqVideo;
		itqVideoPlayer = itqVideo.get(0);

		itqVideo.removeAttr('autoplay');

		var videoFullwidth = itqVideo.parent().parent();
		$('<div class="itq-video__button"><i class="fa fa-pause"></i></div>').prependTo(videoFullwidth);
		$('<div class="itq-video__progress"><span></span></div>').appendTo(videoFullwidth);

		itqVideo.on('click', function() {
			if (itqVideoPaused) {
				itqVideoPlay();
				itqVideoPaused = false;
			} else {
				itqVideoPause();
				itqVideoPaused = true;
			}
		});

		itqVideo.on('timeupdate', function() {
			var currentTime = itqVideoPlayer.currentTime;
			var duration = itqVideoPlayer.duration;

			if (!currentTime || !duration) {
				$('.itq-video__progress span').css('width', 0);

				return;
			}

			var progressWidth = Math.round((currentTime / duration) * 100);
			$('.itq-video__progress span').css('width', progressWidth + '%');
		});

		$('.itq-video__button').on('click', function(event) {
			event.stopPropagation();

			// itqVideoPlayer.muted = false;
			// itqVideoPlayer.volume = 1;

			itqVideo.trigger('click');
		});

		$('.itq-video__progress').on('click', function(event) {
			event.stopPropagation();

			// itqVideoPlayer.muted = false;
			// itqVideoPlayer.volume = 1;

		    var clickPercent = event.pageX / $(this).width();
		    itqVideoPlayer.currentTime = clickPercent * itqVideoPlayer.duration;
		});
  }

  function initSelectFields() {
    $('select[name="galleries-archive"]').each(function() {
      var el = $(this);

      el.chosen({
        disable_search: true,
      });
    });

    $('.gform_wrapper select').each(function() {
      var el = $(this);

      var placeholder = el.find('.gf_placeholder').text();

      el.chosen({
        disable_search_threshold: 8,
      });
    });
  }

  function initTouchMenuHover() {
    var touch = matchMedia('(hover: none)').matches;

    if (!touch) {
      return;
    }

    $('.menu-item-has-children').on('click', function(event) {
      if (!$(this).hasClass('fusion-active-link')) {
        event.preventDefault();
        return;
      }
    });
  }

  function itqVideoPause() {
		itqVideoPlayer.pause();
		$('.itq-video__button').html('<i class="fa fa-play"></i>');
	}

	function itqVideoPlay() {
		itqVideoPlayer.play();
		$('.itq-video__button').html('<i class="fa fa-pause"></i>');
  }

  function itqVideoScroll() {
    if (!itqVideoGlobal || itqVideoPaused) {
			return;
		}

		var scrolledTop = $(window).scrollTop();
		var itqVideoOffset = itqVideoGlobal.offset().top;
		var windowHeight = window.innerHeight;

		if (scrolledTop > itqVideoOffset - windowHeight / 3 && scrolledTop < itqVideoOffset + windowHeight * 0.75) {
			itqVideoPlay();
		} else {
			itqVideoPause();
		}
  }

	function lazyLoadImages(gallery, activeOnly) {
		if (typeof activeOnly === 'undefined') {
			activeOnly = true;
		}

		var images = activeOnly ? '.owl-item.active img[data-src]' : 'img[data-src]';
		gallery.find(images).each(function() {
			$(this).attr('src', $(this).attr('data-src'));
		});

		gallery.addClass('galleries__post__images--loaded');
  }

	$(document).ready(function() {
    initItqVideo();
    initTouchMenuHover();

		$('.galleries__archive-select select').on('change', function() {
			if ($(this).val() === '') {
				window.location.href = $(this).attr('data-url');
				return;
			}

			window.location.href = $(this).attr('data-url') + '?gallery_year=' + $(this).val();
		});

		var galleries = $('.galleries__post__images');
		galleries.owlCarousel({
			center: false,
  			dots: false,
  			margin: 12,
  			nav: true,
			navText: ['', ''],
			responsiveBaseElement: $('#wrapper').get(0),
			responsive: {
			    0: {
			        items: 1
			    },
			    420: {
			        items: 2
			    },
			    720: {
			        items: 3
			    },
			    1024: {
			        items: 4
			    }
			}
  		});

		galleries.on('changed.owl.carousel', function(event) {
			var target = $(event.currentTarget);
			if (typeof target === 'undefined') {
				return;
			}

			lazyLoadImages(target, false);
    });
	});

	$(window).load(function() {
    evaluateImageLoading();
    initSelectFields();
	});

	$(window).on('resize', throttle(function() {
		evaluateImageLoading();
	}, 500));

	$(window).on('scroll', throttle(function() {
    evaluateImageLoading();
    itqVideoScroll();
	}, 200));
})(jQuery);
